import { Divider } from "@mui/material";
import config from "../config";
import { ImagesInfo } from "../Utilities";
import TemplateCheckbox from "./TemplateCheckbox";

interface Props {
  label: string;
  imagesArray: ImagesInfo[];
  cropGroupSelected: string | null;
}

export default function BulkDownloadImagesGroup(props: Props) {
  return (
    <div className="my-4 mx-2 " key={props.label}>
      <div className="font-skyMedium text-xl">
        {props.label}
        <Divider></Divider>
      </div>

      {props.imagesArray.map(
        (image, index) =>
          image.isDownloadable && (
            <div
              className="flex flex-wrap justify-between items-center my-6 "
              key={image.uuid}
            >
              <div className="w-full md:w-1/3">
                <img
                  alt={image.title}
                  src={
                    image.proxy != null
                      ? config.cloudfrontImgUrl +
                        "" +
                        image.proxy +
                        config.showImagesQuery
                      : config.placeholderImageUrl
                  }
                ></img>
              </div>
              <div className="w-full md:w-2/3 px-2">
                {image.availableTemplatesByCropGroup ? (
                  <>
                    {image.availableTemplatesByCropGroup.map(
                      (availableTemplate, index) => (
                        <TemplateCheckbox
                          key={props.label + "-" + image.uuid + "-" + index}
                          availableTemplate={availableTemplate}
                          cropGroupSelected={props.cropGroupSelected}
                        ></TemplateCheckbox>
                      )
                    )}
                  </>
                ) : (
                  <div>Select crop group</div>
                )}
              </div>
            </div>
          )
      )}
    </div>
  );
}
